export class DataCalendarState {
  /**
   * @var Object
   */
  modelSet = {};
}
